import React from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import styles from "./Hero.module.sass";
import Image from "../../../components/Image";
import ScrollButton from "../../../components/ScrollButton";

const Hero = ({ scrollToRef }) => {
    return (
        <div className={styles.hero}>
            <div className={cn("container", styles.container)}>
                <div className={styles.wrap}>
                    <div className={cn("stage", styles.stage)}>
                        Learn Together. Grow Together
                    </div>
                    <h1 className={cn("h1", styles.title)}>
                        Workout with Influencers
                    </h1>
                    <div className={styles.text}>
                        Don’t Just Follow. Engage, Mirror, and Excel with Gainify.
                    </div>
                    <div className={styles.btns}>
                        <Link
                            className={cn("button", styles.purpleButton)}
                            to="/download"
                        >
                            Download App
                        </Link>
                    </div>
                </div>
                <ScrollButton
                    onScroll={() =>
                        scrollToRef.current.scrollIntoView({
                            behavior: "smooth",
                        })
                    }
                    className={styles.scroll}
                />
                <div className={styles.gallery}>
                    <div className={cn(styles.watchPreview)}>
                        <Image
                            srcSet="/images/content/6-5-active-workout.png"
                            srcSetDark="/images/content/6-5-active-workout.png"
                            src="/images/content/6-5-active-workout.png"
                            srcDark="/images/content/6-5-active-workout.png"
                            alt="Watch"
                        />
                    </div>
                    <div className={styles.preview}>
                        <img
                            srcSet="/images/content/bottle@2x.png 2x"
                            src="/images/content/bottle.png"
                            alt="Bottle"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Hero;
